// cfa: Courses For Approval
import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { triggerNotification } from "../../component/message/Msg";
import config from "../../config";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import Spinner from "../../component/loadingbar/Spinner";
import Rating from "../../component/rating/Rating";
import StarRatings from "react-star-ratings";
import Swal from "sweetalert2";
import noImg from "../../assetsCon/assets/images/noImg.png";
import moment from "moment";

const ViewCourse = () => {
  const { id, cfa } = useParams();
  const { token, user_type, host_url } = config;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [popupLoading, setPopupLoading] = useState(false);
  const [showVideoModal, setShowVideoModal] = useState(false);
  // const [playVideo, setPlayVideo] = useState(false);
  // const videoRef = useRef(null);

  //----------------------------------------------- manage states -----------------------------------------------
  const [courseDetails, setCourseDetails] = useState({});
  const [materials, setMaterials] = useState([]);
  const [assignments, setAssignments] = useState([]);
  const [assignmentDetail, setAssignmentDetail] = useState({});
  const [chatOff, setChatOff] = useState(false);
  const [chats, setChats] = useState({});
  const [chatMsg, setChatMsg] = useState({
    chatTxt: "",
    chatTo: "",
  });

  // const toggleVideo = () => {
  //   const video = videoRef.current;
  //   if (playVideo) {
  //     video.pause();
  //   }
  //   setPlayVideo(!playVideo);
  // };

  const changeChatMsg = (e) => {
    setChatMsg({
      ...chatMsg,
      chatTxt: e.target.value,
    });
  };

  function capitalizeName(name) {
    return name?.replace(/\b\w/g, function (char) {
      return char.toUpperCase();
    });
  }
  //----------------------------------------------- enable / disable Course -----------------------------------------------
  const enabledisableCourseBtn = (params) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You are about to ${
        courseDetails.status === 0 ? "approve " : "reject "
      } course. Are you sure you want to proceed?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${
        courseDetails.status === 0 ? "approve " : "reject "
      }  it!`,
    }).then((result) => {
      if (result.isConfirmed) {
        enabledisableCourse();
      }
    });

    //If confirm then enable/ disable course
    const enabledisableCourse = async () => {
      try {
        await fetch(
          `${host_url}course/${params === "y" ? "status" : "at-status"}/${atob(
            id
          )}/${courseDetails.status === 0 ? "1" : "0"}`,
          {
            method: "GET",
            headers: {
              token: token,
            },
          }
        )
          .then((response) => response.json())
          .then(function (data) {
            if (data.status === 200) {
              triggerNotification(
                "success",
                `Course ${
                  courseDetails.status === 0 ? "approved" : "rejected"
                } successfully`
              );
              getCourse();
            } else if (data.status === 404) {
              // course IDs Not Found
              console.error("Course ID is not found");
              triggerNotification("error", "Course ID is not found");
            } else if (data.status === 401) {
              // Invalid Token
              console.error("Invalid token");
              triggerNotification("error", "Unauthenticated User");
            } else {
              // Internal Server Error or other HTTP errors
              console.error("Internal server error");
              triggerNotification(
                "error",
                "Internal server error, Please try after some time!"
              );
            }
          });
      } catch (error) {
        console.error(
          `Error ${
            courseDetails.status === 0 ? "approving" : "rejecting"
          } course`,
          error
        );
        triggerNotification(
          "error",
          `Error ${
            courseDetails.status === 0 ? "approving" : "rejecting"
          } course`
        );
      }
    };
  };

  //----------------------------------------------- select / get / view course, chat  -------------------------------------------------R
  const getCourse = async () => {
    setLoading(true);
    try {
      await fetch(
        `${host_url}pages/coursedetail/${decodeURIComponent(atob(id))}`,
        {
          method: "GET",
          headers: {
            token: token,
          },
        }
      )
        .then((response) => response.json())
        .then(async (data) => {
          if (data.status === 200) {
            if (
              user_type === "admin" &&
              data.data.course_owner.type !== "admin" &&
              data.data.course_owner.id !== 0
            ) {
              console.log(data.data.course_owner.id !== 0);
              getChatData(data.data.course_owner.id);
              setChatMsg({
                ...chatMsg,
                chatTo: data.data.course_owner.id,
              });
            } else if (
              (user_type === "admin" &&
                data.data.course_owner.type === "admin") ||
              data.data.course_owner.id === 0
            ) {
              setChatOff(true);
            }

            await setCourseDetails(data.data);

            await setMaterials(data.data.materials);
            await setAssignments(data.data.assignment);

            // console.log(data.data.assignment);
            // console.log("teachers : ", data.data.teachers);
            // console.log("data : ", data);
          } else if (data.status === 401) {
            // Invalid token
            triggerNotification("error", "Unauthenticated user");
          } else {
            // Handle other errors
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!!"
            );
          }
        });
    } catch (error) {
      triggerNotification("error", "Error fetching courses.");
    } finally {
      setLoading(false);
    }
  };
  const getChatData = async (adminTeacherId) => {
    try {
      {
        (user_type === "admin" ||
          user_type === "teacher" ||
          user_type === "TPT") &&
          (await fetch(
            `${host_url}admin-teacher/chat-messages?id=${adminTeacherId}`,
            {
              method: "GET",
              headers: {
                token: token,
              },
            }
          )
            .then((response) => response.json())
            .then(async (data) => {
              if (data.status === 200) {
                setChats(data.data);
              } else if (data.status === 401) {
                // Invalid token
                triggerNotification("error", "Unauthenticated user");
              } else {
                // Handle other errors
                triggerNotification(
                  "error",
                  "Internal server error, Please try after some time!!"
                );
              }
            }));
      }
    } catch (error) {
      triggerNotification("error", "Error fetching chats.");
    }
  };
  const getAdminId = async () => {
    setLoading(true);
    try {
      await fetch(`${host_url}admin-teacher/chat-messages?getadmin=1`, {
        method: "GET",
        headers: {
          token: token,
        },
      })
        .then((response) => response.json())
        .then(async (data) => {
          if (data.status === 200) {
            await setChatMsg({
              ...chatMsg,
              chatTo: data.data.adminid,
            });
            getChatData(data.data.adminid);
          } else if (data.status === 401) {
            // Invalid token
            triggerNotification("error", "Unauthenticated user");
          } else {
            // Handle other errors
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!!"
            );
          }
        });
    } catch (error) {
      triggerNotification("error", "Error fetching chats.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id !== undefined) {
      getCourse();
      user_type !== "admin" && getAdminId();
    }
  }, [id]);

  //----------------------------------------------- select / view teachers & chapter table  -------------------------------------------------R
  const btnShowTeacherHandle = (chid) => {
    const encodedId = window.btoa(encodeURIComponent(chid));
    navigate(`/viewteacher/${encodedId}/${id}`);
  };

  const btnShowChapterHandle = async (chid) => {
    const encodedId = window.btoa(encodeURIComponent(chid));
    navigate(`/viewchapter/${encodedId}/course/${id}`);
    // setPopupLoading(true);
    // try {
    //   await fetch(`${host_url}chapter/${id}`, {
    //     method: "GET",
    //     headers: {
    //       token: token,
    //     },
    //   })
    //     .then((response) => response.json())
    //     .then((data) => {
    //       if (data.status === 200) {
    //         // Successful response, update the chapters state
    //         setChapterDetail(data.data);
    //       } else if (data.status === 401) {
    //         // Invalid token
    //         triggerNotification("error", "Unauthenticated user");
    //       } else {
    //         // Handle other errors
    //         triggerNotification(
    //           "error",
    //           "Internal server error, Please try after some time!!"
    //         );
    //       }
    //     });
    // } catch (error) {
    //   triggerNotification("error", "Error fetching chapter data.");
    // } finally {
    //   setPopupLoading(false);
    // }
  };

  const btnShowAssignmentHandle = async (id) => {
    setPopupLoading(true);
    try {
      await fetch(`${host_url}assignments/${id}`, {
        method: "GET",
        headers: {
          token: token,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            // Successful response, update the chapters state
            // console.log(data.data);
            setAssignmentDetail(data.data);
          } else if (data.status === 401) {
            // Invalid token
            triggerNotification("error", "Unauthenticated user");
          } else {
            // Handle other errors
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!!"
            );
          }
        });
    } catch (error) {
      triggerNotification("error", "Error fetching assignment data.");
    } finally {
      setPopupLoading(false);
    }
  };

  // const docs = [
  //   {
  //     uri: "https://www.simplilearn.com/ice9/free_resources_article_thumb/What_are_the_Entry_Requirements_for_an_MBA.jpg",
  //     fileType: "jpg",
  //     fileName: "What_are_the_Entry_Requirements_for_an_MBA.jpg",
  //   },
  // ];

  // ------------------------------------------------------------------ Delete material/assignment -----------------------------------------------------D
  const handleDeleteBtn = (id, i, assignment) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You are about to delete ${
        assignment ? "assignment" : "material"
      }. Are you sure you want to proceed?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDelete(id, i, assignment);
      }
    });
    //Confirm delete
    const handleDelete = (id, i, assignment) => {
      fetch(
        `${host_url}${assignment ? "assignments" : "course/materials"}/${id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
        }
      )
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (data.status === 200) {
            triggerNotification(
              "success",
              `${assignment ? "Assignment" : "Material"} deleted successfully`
            );
            const updatedData = assignment ? [...assignments] : [...materials];
            updatedData.splice(i, 1);
            assignment
              ? setAssignments(updatedData)
              : setMaterials(updatedData);
          } else if (data.status === 404) {
            triggerNotification(
              "error",
              `${assignment ? "Assignment" : "Material"} not found`
            );
          } else if (data.status === 401) {
            triggerNotification("error", "Unauthenticated User");
          } else {
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!"
            );
          }
        })
        .catch(function (error) {
          console.error("Error:", error);
          triggerNotification(
            "error",
            `Error deleting ${assignment ? "assignment" : "material"} `
          );
        });
    };
  };

  // ---------------------------------------------------- edit Assignment -----------------------------------------------------U
  const handleEditAssgBtn = (aid) => {
    navigate(`/addassignmentque/${btoa(encodeURIComponent(aid))}/course/${id}`);
  };

  // ------------------------------------------------- Edit / Update Plan ---------------------------------------------------- U
  const btnEditHandle = (pid) => {
    const encodedId = window.btoa(encodeURIComponent(pid));
    navigate(`/addplan/courseid/${id}/${encodedId}`);
  };

  // ---------------------------------------------------- Delete plan ---------------------------------------------------------D
  // Show a confirmation dialog
  const btnDeletePlanHandle = (deleteId, i) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to delete plan. Are you sure you want to proceed?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDeletePlan(deleteId, i);
      }
    });
  };
  //If confirm then delete plan
  const handleDeletePlan = async (deleteId, i) => {
    try {
      await fetch(`${host_url}plans/${deleteId}`, {
        method: "DELETE",
        headers: {
          token: token,
        },
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (data.status === 200) {
            triggerNotification("success", "Plan deleted successfully");
            const updatedPlans = [...courseDetails.plans];
            updatedPlans.splice(i, 1);
            setCourseDetails((prevCourseDetail) => ({
              ...prevCourseDetail,
              plans: updatedPlans,
            }));
          } else if (data.status === 404) {
            // plan IDs Not Found
            console.error("Plan ID is not found");
            triggerNotification("error", "plan ID is not found");
          } else if (data.status === 401) {
            // Invalid Token
            console.error("Invalid token");
            triggerNotification("error", "Unauthenticated User");
          } else {
            // Internal Server Error or other HTTP errors
            console.error("Internal server error");
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!"
            );
          }
        });
    } catch (error) {
      console.error("Error deleting plan:", error);
      triggerNotification("error", "Error deleting plan");
    }
  };

  // ---------------------------------------------- create / add / update course ----------------------------------------------------c--u
  // Function to create a new course
  const handleSendMsg = async () => {
    try {
      if (!chatMsg.chatTxt.trim()) {
        return;
      }
      fetch(
        `${config.host_url}admin-teacher/send-message?id=${chatMsg.chatTo}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
          body: JSON.stringify({
            msg: chatMsg.chatTxt,
          }),
        }
      )
        .then((response) => response.json())
        .then((data) => {
          // console.log("data : ", data);
          if (data.status === 200) {
            setChatMsg({
              ...chatMsg,
              chatTxt: "",
            });
            getChatData(chatMsg.chatTo);
          } else if (data.status === 400) {
            // Handle validation errors
            triggerNotification("error", "Validation Error.");
          } else if (data.status === 401) {
            // Handle unauthorized (invalid token)
            triggerNotification("error", "Unauthenticated user");
          } else {
            // Handle other server errors
            triggerNotification("error", "Internal server error.");
          }
        })
        .catch((error) => {
          console.error("Fetch error:", error);
        });
    } catch (error) {
      console.error("Error sending message:", error);
      triggerNotification(
        "error",
        "An error occurred while sending the message"
      );
    }
  };

  return (
    <>
      {cfa === "yes" ? (
        <Breadcrumb
          txt="Manage Course"
          subpath={["Courses For Approval", "Course Details"]}
          url={["/coursesforapproval"]}
        />
      ) : (
        <Breadcrumb
          txt="Manage Course"
          subpath={["View Courses", "Course Details"]}
          url={["/viewcourses"]}
        />
      )}

      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-body row g-3">
            {loading ? (
              <Spinner />
            ) : (
              <div className="col-lg-12">
                <div className="d-flex justify-content-between align-items-center flex-wrap mb-2 gap-1">
                  <div className="me-1 ">
                    <h5 className="mb-1">
                      {courseDetails.course_name}{" "}
                      {courseDetails?.course_owner?.name && (
                        <span>
                          [By:{" "}
                          {courseDetails.course_owner?.type === "teacher" ||
                          courseDetails.course_owner?.type === "TPT" ? (
                            <a
                              className="p-0 m-0"
                              href={`/viewteacher/${btoa(
                                encodeURIComponent(
                                  courseDetails.course_owner.id
                                )
                              )}`}
                            >
                              {capitalizeName(courseDetails.course_owner?.name)}
                            </a>
                          ) : (
                            capitalizeName(courseDetails.course_owner?.name)
                          )}
                          ]
                        </span>
                      )}
                    </h5>
                  </div>
                  {/* {user_type === "admin" && (
                    <div
                      className={`btn ${
                        courseDetails.status === 0
                          ? "btn-primary"
                          : " btn-secondary"
                      }`}
                      onClick={enabledisableCourseBtn}
                    >
                      {courseDetails.status === 0
                        ? "Approve Course"
                        : "Reject Course"}
                    </div>
                  )} */}
                </div>
                <div className="card academy-content shadow-none border">
                  <div className="p-2">
                    <div className="cursor-pointer">
                      <img
                        className="w-100 h-96 rounded"
                        src={courseDetails.image_link}
                        alt="Course Image"
                      />
                    </div>
                  </div>
                  <div className="card-body">
                    {/* Teachers */}
                    <h5 className="mb-2">Teachers</h5>
                    <ul className="list-unstyled  d-flex avatar-group my-3 mx-3">
                      {courseDetails.teachers &&
                        courseDetails.teachers.map((teacher) => (
                          <li
                            key={teacher.tid}
                            data-bs-toggle="tooltip"
                            data-popup="tooltip-custom"
                            data-bs-placement="top"
                            title={teacher.teacher_name}
                            className="avatar-xl me-2 pull-up"
                            onClick={() => {
                              btnShowTeacherHandle(teacher.tid);
                            }}
                          >
                            <img
                              className="rounded-circle h-16 w-16"
                              src={teacher.profile ? teacher.profile : noImg}
                              alt="Avatar"
                            />
                          </li>
                        ))}
                    </ul>

                    {/* About this course */}
                    <hr className="my-4" />
                    <h5 className="mb-2">About this course</h5>
                    <p className="mb-0 pt-1">
                      {courseDetails.short_description}
                    </p>

                    {/* thumbnail */}
                    <div className="col-sm-3 ">
                      <div
                        onClick={() => {
                          setShowVideoModal(true);
                        }}
                        className="relative mt-3 border rounded "
                      >
                        <img
                          src={courseDetails.video_thumbnail}
                          alt="Video Thumbnail"
                          className="cursor-pointer rounded object-cover h-32 w-full "
                        />
                        <span
                          className="mdi mdi-play mdi-24px mdi-dark px-1 bg-white rounded absolute top-[50%] left-[50%] opacity-90	"
                          style={{ transform: "translate(-50%, -50%)" }}
                        ></span>
                      </div>
                    </div>

                    {/* Ratings & Reviews */}
                    <hr className="my-4" />
                    <h5>Ratings & Reviews</h5>
                    <div className="flex">
                      {courseDetails.reviews &&
                        courseDetails.reviews.length !== 0 && (
                          <div>
                            {courseDetails.ratingTotal !== undefined ? (
                              <h3 className="flex items-center">
                                <span>{courseDetails.ratingTotal}</span>
                                <span className="mx-2 mb-1">
                                  <StarRatings
                                    rating={1}
                                    starRatedColor="green"
                                    numberOfStars={1}
                                    starDimension="25px"
                                  />
                                </span>
                                <span>out of 10</span>
                              </h3>
                            ) : (
                              "Rating not available"
                            )}
                          </div>
                        )}
                    </div>
                    <p>
                      {courseDetails.reviews && courseDetails.reviews.length}{" "}
                      global ratings{" "}
                    </p>
                    <div className="row ">
                      {courseDetails.reviews &&
                        courseDetails.reviews.map((review, i) => (
                          <Rating
                            key={i}
                            stars={review.rating}
                            review={review.review}
                            sname={review.first_name + " " + review.last_name}
                            reviewDate={review.created_at}
                          />
                        ))}
                    </div>

                    {/* Details */}
                    <hr className="my-4" />
                    <h5>Details</h5>
                    <div className=" table-responsive">
                      <table>
                        <tbody>
                          <tr>
                            <td>
                              <div className="me-5">
                                <p className="text-nowrap">
                                  <i
                                    className={`${config.rupee_icon} mdi-24px me-2`}
                                  ></i>
                                  Price : {courseDetails.price}
                                </p>
                              </div>
                            </td>
                            <td>
                              <div className="me-5">
                                <p className="text-nowrap">
                                  <i className="mdi mdi-calendar mdi-24px me-2"></i>
                                  From:{" "}
                                  {courseDetails.start_date &&
                                    courseDetails.start_date.slice(8, 10)}
                                  /
                                  {courseDetails.start_date &&
                                    courseDetails.start_date.slice(5, 7)}
                                  /
                                  {courseDetails.start_date &&
                                    courseDetails.start_date.slice(0, 4)}{" "}
                                  {courseDetails.start_date &&
                                    courseDetails.start_date.slice(11, 19)}
                                </p>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div className="me-5">
                                <p className="text-nowrap">
                                  <i className="mdi mdi-timer-outline mdi-24px me-2"></i>
                                  Duration: {courseDetails.course_duration}{" "}
                                  {courseDetails.duration_unit}
                                </p>
                              </div>
                            </td>
                            <td>
                              <div className="me-5">
                                <p className="text-nowrap">
                                  <i className="mdi mdi-calendar-end mdi-24px me-2"></i>
                                  To:{" "}
                                  {courseDetails.end_date &&
                                    courseDetails.end_date.slice(8, 10)}
                                  /
                                  {courseDetails.end_date &&
                                    courseDetails.end_date.slice(5, 7)}
                                  /
                                  {courseDetails.end_date &&
                                    courseDetails.end_date.slice(0, 4)}{" "}
                                  {courseDetails.end_date &&
                                    courseDetails.end_date.slice(11, 19)}
                                </p>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div className="me-5">
                                <p className="text-nowrap">
                                  <i className="mdi mdi-account-multiple-outline  mdi-24px me-2"></i>
                                  Subscriber: {courseDetails.subscriber}
                                </p>
                              </div>
                            </td>
                            {courseDetails.category && (
                              <td>
                                <div className="me-5">
                                  <p className="text-nowrap">
                                    <i className="mdi mdi-checkerboard mdi-24px me-2"></i>
                                    Category: {courseDetails.category}
                                  </p>
                                </div>
                              </td>
                            )}
                          </tr>
                          <tr>
                            {courseDetails.target_audience && (
                              <td>
                                <div className="me-5">
                                  <p className="text-nowrap">
                                    <i className="mdi mdi-account-search-outline  mdi-24px me-2"></i>
                                    Target Audience:{" "}
                                    {courseDetails.target_audience}
                                  </p>
                                </div>
                              </td>
                            )}

                            {courseDetails.description_file && (
                              <td>
                                <div className="me-5">
                                  <p className="text-nowrap">
                                    <i className="mdi mdi-file-document-outline  mdi-24px me-2"></i>
                                    Description File:{" "}
                                    <span
                                      className=" border px-1 bg-gray-100 rounded shadow-sm text-blue-400"
                                      onClick={() =>
                                        navigate(
                                          `/fileanddocviewer/${id}/${btoa(
                                            encodeURIComponent(
                                              courseDetails.description_file
                                            )
                                          )}/description/course`
                                        )
                                      }
                                    >
                                      Preview
                                    </span>
                                  </p>
                                </div>
                              </td>
                            )}
                          </tr>
                          <tr>
                            {courseDetails.incentive && (
                              <td>
                                <div className="me-5">
                                  <p className="text-nowrap">
                                    <i className="mdi mdi-gift-outline  mdi-24px me-2"></i>
                                    Incentive: {courseDetails.incentive}
                                  </p>
                                </div>
                              </td>
                            )}
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    {/* Live Class */}
                    {courseDetails.live_class_status === 1 && (
                      <div className="mb-4">
                        <hr className="mb-4 mt-2" />
                        <h5>Live Class</h5>
                        <table>
                          <tr>
                            <td colSpan={"2"}>
                              <p>
                                <span className="font-semibold	">
                                  {"Description: "}
                                </span>
                                {courseDetails?.live_class_description}
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div className="me-5">
                                <p className="text-nowrap">
                                  <i className="mdi mdi-clock-start  mdi-24px me-2"></i>
                                  Scheduled Start Time:{" "}
                                  {moment(
                                    courseDetails?.live_class_start
                                  ).format("Do MMM 'YY, h:mm:ss a")}
                                </p>
                              </div>
                            </td>
                            {/* <td>
                              <div className="me-5">
                                <p className="text-nowrap">
                                  <i className="mdi mdi-clock-end mdi-24px me-2"></i>
                                  Scheduled End Time:{" "}
                                  {moment(courseDetails?.live_class_end).format(
                                    "Do MMM 'YY, h:mm:ss a, "
                                  )}
                                </p>
                              </div>
                            </td> */}
                            <td>
                              <div className="me-5">
                                <p className="text-nowrap">
                                  <i className="mdi mdi-gesture-tap  mdi-24px me-2"></i>
                                  Is Chapter Enable During Live Class:{" "}
                                  {courseDetails?.is_chapter_enable_during_live_class ===
                                  1
                                    ? "Yes"
                                    : "No"}
                                </p>
                              </div>
                            </td>
                          </tr>

                          {/* link | file */}
                          <tr>
                            <td>
                              <a
                                href={courseDetails.live_class_link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="border px-1 bg-gray-100 rounded shadow-sm text-blue-400"
                              >
                                {courseDetails.live_class_link}
                              </a>
                            </td>
                            <td>
                              {courseDetails.live_class_instruction_file && (
                                <div className="flex select-none ">
                                  <span className="mr-2 font-semibold">
                                    {"Instruction File :"}
                                  </span>
                                  <h6 className="text-slate-950/50">
                                    <a
                                      href={
                                        courseDetails?.live_class_instruction_file
                                      }
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className=" border px-1 bg-gray-100 rounded shadow-sm text-blue-400"
                                    >
                                      Open
                                    </a>
                                  </h6>
                                </div>
                              )}
                            </td>
                          </tr>
                        </table>
                      </div>
                    )}

                    {/* Recorded Class Link */}
                    {courseDetails.live_class_recorded_video_link && (
                      <div className="mb-4">
                        <hr className="mb-4 mt-2" />
                        <h5>Recorded Class Link</h5>
                        <a
                          href={courseDetails.live_class_recorded_video_link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="border px-1 bg-gray-100 rounded shadow-sm text-blue-400"
                        >
                          {courseDetails.live_class_recorded_video_link}
                        </a>
                      </div>
                    )}

                    {/* Description */}
                    <hr className="mb-4 mt-2" />
                    <h5>Description</h5>
                    <p className="mb-4">{courseDetails.long_description}</p>

                    {/* Plan */}
                    <div>
                      <div className="flex justify-between items-center mb-3 mt-2">
                        <div>
                          <h5 className="p-0 m-0 inline-block align-baseline">
                            Plans
                          </h5>
                          {((courseDetails.admin_status === 0 &&
                            user_type === "admin") ||
                            (courseDetails.teacher_status === 0 &&
                              courseDetails.admin_status === 1 &&
                              user_type === "teacher") ||
                            (courseDetails.teacher_status === 0 &&
                              courseDetails.admin_status === 1 &&
                              user_type === "TPT") ||
                            (courseDetails.status === 1 &&
                              user_type === "admin")) && (
                            <div
                              className={`btn ml-3 ${
                                courseDetails.status === 0
                                  ? "btn-primary"
                                  : " btn-secondary"
                              }`}
                              onClick={() =>
                                courseDetails.status === 1 &&
                                user_type === "admin"
                                  ? enabledisableCourseBtn("y")
                                  : enabledisableCourseBtn("n")
                              }
                            >
                              {courseDetails.status === 0
                                ? "Approve Course"
                                : "Reject Course"}
                            </div>
                          )}
                        </div>

                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={() => navigate(`/addplan/courseid/${id}`)}
                        >
                          Add Plan
                        </button>
                      </div>
                      {courseDetails.plans &&
                        courseDetails.plans.length > 0 && (
                          <div className=" table-responsive">
                            <table className="table table-bordered select-none">
                              <thead>
                                <tr>
                                  <th>Plan</th>
                                  <th>Duration </th>
                                  <th>Price </th>
                                  <th>Actions</th>
                                </tr>
                              </thead>
                              <tbody>
                                {courseDetails.plans &&
                                  courseDetails.plans.map((plan, i) => (
                                    <tr key={plan.cpid} className="select-none">
                                      <td className="align-top col-sm-2 ">
                                        {i + 1}
                                      </td>
                                      <td className="align-top col-sm-2 ">
                                        {plan.plan_for + " " + plan.plan_unit}
                                      </td>
                                      <td className="align-top col-sm-2 ">
                                        {plan.promotional_price ? (
                                          <div className="">
                                            <small>
                                              <del>{plan.plan_price}</del>
                                            </small>
                                            <p>{plan.promotional_price}</p>
                                          </div>
                                        ) : (
                                          plan.plan_price
                                        )}
                                      </td>
                                      <td className="align-top col-sm-2 ">
                                        <button
                                          type="button"
                                          className="btn btn-icon btn-secondary m-2"
                                          onClick={() => {
                                            btnEditHandle(plan.cpid);
                                          }}
                                        >
                                          <span className="tf-icons mdi mdi-pencil"></span>
                                        </button>

                                        <button
                                          type="button"
                                          className="btn btn-icon btn-danger m-2"
                                          onClick={() => {
                                            btnDeletePlanHandle(plan.cpid, i);
                                          }}
                                        >
                                          <span className="tf-icons mdi mdi-delete"></span>
                                        </button>
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                          </div>
                        )}
                    </div>

                    {/* Materials */}
                    <hr className="mb-4 mt-2" />
                    <h5 className=""> Materials</h5>
                    <div className=" mb-4">
                      {materials && materials.length <= 0 ? (
                        <p> Materials not available.</p>
                      ) : (
                        <div className="table-responsive">
                          <table className="table">
                            <tbody>
                              {materials &&
                                materials.map((material, i) => {
                                  return (
                                    <tr key={i}>
                                      <td className="text-truncate text-heading flex justify-between">
                                        <a
                                          onClick={() =>
                                            navigate(
                                              `/fileanddocviewer/${id}/${btoa(
                                                encodeURIComponent(
                                                  material.material
                                                )
                                              )}/materia/course`
                                            )
                                          }
                                        >
                                          <span>
                                            <i className="mdi mdi-file mdi-20px text-success me-3"></i>
                                            Material
                                          </span>
                                        </a>
                                        <span
                                          className="menu-icon tf-icons mdi mdi-delete  col ml-4"
                                          onClick={() =>
                                            handleDeleteBtn(
                                              material.mid,
                                              i,
                                              false
                                            )
                                          }
                                        ></span>
                                      </td>
                                    </tr>
                                  );
                                })}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>

                    {/* Assignments */}
                    <h5 className=""> Assignments</h5>
                    <div className=" mb-4">
                      {assignments && assignments.length <= 0 ? (
                        <p> Assignment not available.</p>
                      ) : (
                        <div className="table-responsive">
                          <table className="table">
                            <tbody>
                              {assignments &&
                                assignments.map((assignment, i) => {
                                  return (
                                    <tr key={i}>
                                      <td className="text-truncate text-heading flex justify-between">
                                        <a
                                          href={assignment?.assignment}
                                          onClick={() =>
                                            btnShowAssignmentHandle(
                                              assignment?.caid
                                            )
                                          }
                                          data-bs-toggle="modal"
                                          data-bs-target="#ViewAssignment"
                                        >
                                          <i className="mdi mdi-file mdi-20px text-success me-3"></i>
                                          {assignment?.title}
                                        </a>
                                        <div className="">
                                          <i
                                            className="menu-icon tf-icons mdi mdi mdi-checkbox-multiple-marked  col ml-4"
                                            // data-toggle="view"
                                            title="view"
                                            onClick={() =>
                                              navigate(
                                                `/studentsubmissions/${btoa(
                                                  encodeURIComponent(
                                                    assignment?.caid
                                                  )
                                                )}`
                                              )
                                            }
                                          ></i>
                                          <i
                                            className="menu-icon tf-icons mdi mdi-pencil  col ml-4"
                                            data-toggle="edit"
                                            title="Edit"
                                            onClick={() => {
                                              handleEditAssgBtn(
                                                assignment?.caid
                                              );
                                            }}
                                          ></i>
                                          <i
                                            className="menu-icon tf-icons mdi mdi mdi-delete  col ml-4"
                                            data-toggle="delete"
                                            title="Delete"
                                            onClick={() =>
                                              handleDeleteBtn(
                                                assignment?.caid,
                                                i,
                                                true
                                              )
                                            }
                                          ></i>
                                        </div>
                                      </td>
                                    </tr>
                                  );
                                })}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>

                    {/* Chapters */}
                    <h5>Chapters</h5>
                    <ul className="list-unstyled mb-0">
                      {courseDetails.chapters &&
                        courseDetails.chapters.map((chapter) => (
                          <li
                            key={chapter.chapterid}
                            className="d-flex mb-2 pb-1"
                            onClick={() => {
                              btnShowChapterHandle(chapter.chapterid);
                            }}
                          >
                            <div className="avatar flex-shrink-0 me-3">
                              <span className="avatar-initial rounded bg-label-primary border-2">
                                <img
                                  src={chapter.image_link}
                                  className="mdi mdi-video-outline mdi-24px rounded"
                                  alt="chapter"
                                />
                              </span>
                            </div>
                            <div className="row w-100 align-items-center">
                              <div className="col-sm-8 col-lg-12 col-xxl-8 mb-1 mb-sm-0 mb-lg-1 mb-xxl-0">
                                <h6 className="mb-0 lh-sm">{chapter.name}</h6>
                              </div>
                            </div>
                          </li>
                        ))}
                    </ul>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* chat */}
      {!loading && !chatOff && (
        <div className="app-chat card overflow-hidden">
          <div className="row g-0">
            <div className="col app-chat-history">
              <div className="chat-history-wrapper">
                <div className="chat-history-header border-bottom">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex overflow-hidden align-items-center">
                      <i
                        className="mdi mdi-menu mdi-24px cursor-pointer d-lg-none d-block me-3"
                        data-bs-toggle="sidebar"
                        data-overlay
                        data-target="#app-chat-contacts"
                      ></i>
                      <div className="flex-shrink-0 avatar avatar-online">
                        <img
                          src="../../assets/img/avatars/4.png"
                          alt="Avatar"
                          className="rounded-circle"
                          data-bs-toggle="sidebar"
                          data-overlay
                          data-target="#app-chat-sidebar-right"
                        />
                      </div>
                      <div className="chat-contact-info flex-grow-1 ms-3">
                        <h6 className="m-0">{chats?.reciverinfo?.name}</h6>
                        <span className="user-status">
                          {user_type === "TPT" || user_type === "teacher"
                            ? "Admin"
                            : "Teacher"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="chat-history-body">
                  <ul className="list-unstyled chat-history">
                    {chats?.messages?.map((msg, i) =>
                      //right
                      (user_type !== "admin" && msg?.admin_to !== null) ||
                      (user_type === "admin" && msg?.admin_to === null) ? (
                        <li className="chat-message chat-message-right" key={i}>
                          <div className="d-flex overflow-hidden">
                            <div className="chat-message-wrapper flex-grow-1">
                              <div className="chat-message-text   ">
                                <p className="mb-0 text-white ">{msg.msg}</p>
                              </div>
                              <div className="text-end text-muted">
                                {/* <i className="mdi mdi-check-all mdi-14px text-success me-1"></i> */}
                                <small>
                                  {msg.datetime.slice(8, 10)}/
                                  {msg.datetime.slice(5, 7)}/
                                  {msg.datetime.slice(2, 4)}{" "}
                                  {msg.datetime.slice(11, 19)}
                                </small>
                              </div>
                            </div>
                            <div className="user-avatar flex-shrink-0 ms-3">
                              <div className="avatar avatar-sm">
                                <img
                                  src="../../assets/img/avatars/1.png"
                                  alt="Avatar"
                                  className="rounded-circle"
                                />
                              </div>
                            </div>
                          </div>
                        </li>
                      ) : (
                        //left
                        <li className="chat-message" key={i}>
                          <div className="d-flex overflow-hidden">
                            <div className="user-avatar flex-shrink-0 me-3">
                              <div className="avatar avatar-sm">
                                <img
                                  src="../../assets/img/avatars/4.png"
                                  alt="Avatar"
                                  className="rounded-circle"
                                />
                              </div>
                            </div>
                            <div className="chat-message-wrapper flex-grow-1">
                              <div className="chat-message-text shadow-sm ">
                                <p className="mb-0">{msg.msg}</p>
                              </div>
                              <div className="text-muted">
                                {/* <i className="mdi mdi-check-all mdi-14px text-success me-1"></i> */}
                                <small>
                                  {msg.datetime.slice(8, 10)}/
                                  {msg.datetime.slice(5, 7)}/
                                  {msg.datetime.slice(2, 4)}{" "}
                                  {msg.datetime.slice(11, 19)}
                                </small>
                              </div>
                            </div>
                          </div>
                        </li>
                      )
                    )}
                  </ul>
                </div>
                {/* <!-- Chat message form --> */}
                <div className="chat-history-footer shadow-sm border">
                  <div className=" d-flex justify-content-between align-items-center ">
                    <input
                      className="form-control message-input me-3  shadow-none"
                      placeholder="Type your message here"
                      value={chatMsg.chatTxt}
                      onChange={changeChatMsg}
                    />
                    <div className="message-actions d-flex align-items-center">
                      <button
                        className="btn btn-primary d-flex "
                        onClick={handleSendMsg}
                      >
                        <span className="align-middle">Send</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* modal assignment */}
      <div
        className="modal fade"
        id="ViewAssignment"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl">
          <div className="modal-content pt-2 pb-5 px-md-5">
            <div className="modal-header flex justify-end">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body p-md-0">
              {popupLoading ? (
                <Spinner />
              ) : (
                <div className="col-lg-12">
                  <div className="d-flex justify-content-between align-items-center flex-wrap mb-2 gap-1">
                    <div className="me-1">
                      <h5 className="mb-1">{assignmentDetail.title}</h5>
                    </div>
                  </div>
                  <div className="card academy-content shadow-none ">
                    <div className="card-body">
                      <h5 className="mb-3 mt-2">Assignment Summary</h5>
                      <div
                        className="mb-0 pt-1 p-4 border rounded"
                        dangerouslySetInnerHTML={{
                          __html: assignmentDetail.summary,
                        }}
                      ></div>

                      <hr />

                      <h5 className="mb-1 mt-4">Other Details</h5>
                      <div className="mb-0 pt-1">
                        <ul className="list-unstyled my-3 py-1">
                          <li className="d-flex align-items-center mb-3">
                            <i className="mdi mdi-clock-time-four-outline mdi-24px"></i>
                            <span className="fw-medium mx-2">Created At:</span>{" "}
                            <span>
                              {assignmentDetail.created_at &&
                                assignmentDetail.created_at
                                  .replace("T", " ")
                                  .replace(".000Z", "")}
                            </span>
                          </li>
                          <li className="d-flex align-items-center mb-3">
                            <i className="mdi mdi-timer-outline mdi-24px"></i>
                            <span className="fw-medium mx-2">
                              Time Limit:
                            </span>{" "}
                            <span>
                              {assignmentDetail.time_limit +
                                " " +
                                assignmentDetail.time_limit_unit}
                            </span>
                          </li>

                          <li className="d-flex align-items-center mb-3">
                            <i className="mdi mdi-numeric mdi-24px"></i>
                            <span className="fw-medium mx-2">
                              Total Points:
                            </span>{" "}
                            <span>{assignmentDetail.points}</span>
                          </li>
                          <li className="d-flex align-items-center mb-3">
                            <i className="mdi mdi-check-circle-outline mdi-24px"></i>
                            <span className="fw-medium mx-2">
                              Passing Points:
                            </span>{" "}
                            <span>{assignmentDetail.passing_points}</span>
                          </li>
                          <li className="d-flex align-items-center mb-3">
                            <i className="mdi mdi-file-multiple-outline mdi-24px"></i>
                            <span className="fw-medium mx-2">
                              No Of File Allowed:
                            </span>{" "}
                            <span>{assignmentDetail.no_of_file_allowed}</span>
                          </li>
                          <li className="d-flex align-items-center mb-3">
                            <i className="mdi mdi-file-document-outline mdi-24px"></i>
                            <span className="fw-medium mx-2">
                              Maximum File Size:
                            </span>{" "}
                            <span>{assignmentDetail.max_file_size} MB</span>
                          </li>
                        </ul>
                      </div>
                      {assignmentDetail.assignments &&
                        assignmentDetail.assignments.length > 0 && (
                          <>
                            <hr />
                            <h5 className="mb-1 mt-4">Assignments</h5>
                          </>
                        )}
                      {assignmentDetail.assignments &&
                        assignmentDetail.assignments.map((assignment) => (
                          <>
                            <div
                              className="mb-0 pt-1 my-3 py-1 "
                              data-bs-dismiss="modal"
                              aria-label="Close"
                            >
                              <div
                                onClick={() =>
                                  navigate(
                                    `/fileanddocviewer/${id}/${btoa(
                                      encodeURIComponent(assignment.assignment)
                                    )}/assignment/course`
                                  )
                                }
                              >
                                <i className="mdi mdi-file mdi-20px text-success me-3"></i>
                                Open Assignment
                              </div>
                            </div>
                          </>
                        ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* modal */}
      {showVideoModal && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-gray-600 bg-opacity-30 z-50">
          <div className="w-11/12 md:w-3/4 lg:w-1/2 xl:w-1/3">
            <div className="flex justify-end">
              <button
                className="text-white"
                onClick={() => {
                  setShowVideoModal(false);
                }}
              >
                <span className="mdi mdi-close-box-outline"></span>
              </button>
            </div>
            <video
              src={courseDetails.video_link}
              type="video/mp4"
              playsInline
              controls
              autoPlay
              className="w-full h-full"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default ViewCourse;
